var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUsers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.0002 26.25V23.75C20.0002 22.4239 19.4734 21.1521 18.5356 20.2145C17.5978 19.2768 16.326 18.75 14.9998 18.75H7.49918C6.17299 18.75 4.90112 19.2768 3.96336 20.2145C3.02561 21.1521 2.49878 22.4239 2.49878 23.75V26.25M20.0002 3.90991C21.0725 4.18787 22.0221 4.81399 22.7 5.68999C23.3779 6.56599 23.7457 7.64227 23.7457 8.74991C23.7457 9.85755 23.3779 10.9338 22.7 11.8098C22.0221 12.6858 21.0725 13.3119 20.0002 13.5899M27.5008 26.2499V23.7499C27.5 22.642 27.1312 21.5658 26.4524 20.6902C25.7736 19.8147 24.8232 19.1893 23.7505 18.9124M16.2499 8.75C16.2499 11.5114 14.0111 13.75 11.2495 13.75C8.48783 13.75 6.24908 11.5114 6.24908 8.75C6.24908 5.98858 8.48783 3.75 11.2495 3.75C14.0111 3.75 16.2499 5.98858 16.2499 8.75Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
export default __webpack_public_path__ + "static/media/icon_users.4fd1e73267cb28fef3158d1992dacf77.svg";
export { ForwardRef as ReactComponent };